// CSV export for the Initiatives tables.
//
// Extracted from ManagedPartsTable.jsx and WarehouseBreakdownTable.jsx, which carried byte-identical
// copies of both functions. The escaping and the BOM are the parts that must not drift between
// tables — an export that mangles part numbers in Excel is worse than no export, because nobody
// notices until the numbers are already in a deck.

/** RFC 4180-ish escaping: quote anything containing a comma, quote or newline. */
export function toCsv(rows, columns) {
  const esc = (v) => {
    const s = v === null || v === undefined ? '' : String(v);
    return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  return [
    columns.map((c) => esc(c.label)).join(','),
    ...rows.map((r) => columns.map((c) => esc(r[c.key])).join(',')),
  ].join('\r\n');
}

export function downloadCsv(filename, csv) {
  // BOM so Excel reads UTF-8 part numbers correctly rather than mangling them.
  const blob = new Blob(['﻿', csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/** `managed-parts-sold-2026-07-27.csv` — date-stamped so downloads don't collide in Downloads/. */
export function stampedFilename(stem) {
  return `${stem}-${new Date().toISOString().slice(0, 10)}.csv`;
}
